/**
 * Helpers for managing airbnb data
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */

/**
 * Parses the price string from the airbnb scraper
 * @param {String} price The listing price
 */
export const parsePrice = (price) => {
  if (price.startsWith('Price:')) {
    return price.substring('Price:'.length)
  }

  return price
}
